import { z } from 'zod';

// Same international-format expectation as the auth phone field (matches
// the real API's own example, +2348012345678).
const phoneField = z.string().regex(/^\+[1-9]\d{7,14}$/, 'Use international format, e.g. +2348012345678');

// POST /admin/admins — first_name, last_name, email, phone. Password is
// generated server-side and emailed; never collected here.
export const createAdminSchema = z.object({
  first_name: z.string().min(1, 'Enter a first name'),
  last_name: z.string().min(1, 'Enter a last name'),
  email: z.string().email('Enter a valid email'),
  phone: phoneField,
});

// PUT /admin/admins/{uuid} — only these three fields are ever applied;
// email/password/role are silently dropped server-side even if sent.
export const updateAdminSchema = z.object({
  first_name: z.string().min(1, 'Enter a first name'),
  last_name: z.string().min(1, 'Enter a last name'),
  phone: phoneField,
});

// Shared by "grant admin access" (make-admin) and "unlock account" — both
// take nothing but a target account UUID.
const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const uuidActionSchema = z.object({
  uuid: z.string().trim().regex(uuidRegex, 'Enter a valid account UUID'),
});
